var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 36,
    fill: "#23A8FA",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 19.3333C27.8167 19.3333 20.3333 26.8167 20.3333 36C20.3333 45.1833 27.8167 52.6667 37 52.6667C46.1833 52.6667 53.6667 45.1833 53.6667 36C53.6667 26.8167 46.1833 19.3333 37 19.3333ZM44.9667 32.1667L35.5167 41.6167C35.2833 41.85 34.9667 41.9833 34.6333 41.9833C34.3 41.9833 33.9833 41.85 33.75 41.6167L29.0333 36.9C28.55 36.4167 28.55 35.6167 29.0333 35.1333C29.5167 34.65 30.3167 34.65 30.8 35.1333L34.6333 38.9667L43.2 30.4C43.6833 29.9167 44.4833 29.9167 44.9667 30.4C45.45 30.8833 45.45 31.6667 44.9667 32.1667Z",
    fill: "#23A8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/paymentSuccess.ba7a13260b604d75d45a9e7e4363688a.svg";
export { ForwardRef as ReactComponent };